// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   Grid,
//   TextField,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { getImageUrl } from "../utils/helpFunction";
// import endpoints from "../endpoint";

// const DealsTable = () => {
//   const [deals, setDeals] = useState([]);
//   const [filteredDeals, setFilteredDeals] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchDeals = async () => {
//       try {
//         const response = await axios.get(
//           `${endpoints.serverBaseUrl}api/deals/my-deals`,
//           {
//             withCredentials: true,
//             headers: {
//               Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//             },
//           }
//         );

//         setDeals(response.data);
//         setFilteredDeals(response.data);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDeals();
//   }, []);

//   // Handle Search Filtering
//   useEffect(() => {
//     const filtered = deals.filter(
//       (deal) =>
//         deal.name.toLowerCase().includes(search.toLowerCase()) ||
//         deal.email.toLowerCase().includes(search.toLowerCase()) ||
//         deal.mobile.includes(search)
//     );
//     setFilteredDeals(filtered);
//   }, [search, deals]);

//   const handleDownload = (publicId) => {
//     const url = getImageUrl(publicId);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "payment-proof.png";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <Grid container>
//       <Grid item xs={12} md={12} lg={12} sx={{ borderRadius: 2 }}>
//         {/* Search Input */}
//         <TextField
//           fullWidth
//           variant="outlined"
//           label="Search by Name, Email, or Mobile"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           sx={{ mb: 2 }}
//         />

//         {/* Loading & Error Handling */}
//         {loading ? (
//           <Grid container justifyContent="center" sx={{ py: 4 }}>
//             <CircularProgress />
//           </Grid>
//         ) : error ? (
//           <Typography color="error" align="center">
//             {error}
//           </Typography>
//         ) : (
//           <TableContainer component={Paper}>
//             <Table>
//               <TableHead sx={{ bgcolor: "#1976D2" }}>
//                 <TableRow>
//                   <TableCell sx={{ color: "#fff" }}>Name</TableCell>
//                   <TableCell sx={{ color: "#fff" }}>Email</TableCell>
//                   <TableCell sx={{ color: "#fff" }}>Mobile</TableCell>
//                   <TableCell sx={{ color: "#fff" }}>Category</TableCell>
//                   <TableCell sx={{ color: "#fff" }}>Amount</TableCell>
//                   <TableCell sx={{ color: "#fff" }}>Status</TableCell>
//                   <TableCell sx={{ color: "#fff" }}>Payment Proof</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {filteredDeals.length > 0 ? (
//                   filteredDeals.map((deal) => (
//                     <TableRow key={deal._id} hover>
//                       <TableCell>{deal.name}</TableCell>
//                       <TableCell>{deal.email}</TableCell>
//                       <TableCell>{deal.mobile}</TableCell>
//                       <TableCell>{deal.category}</TableCell>
//                       <TableCell>₹{deal.amountReceived}</TableCell>
//                       <TableCell>{deal.status}</TableCell>
//                       <TableCell>
//                         {deal.paymentProof ? (
//                           <Grid item>
//                             <a
//                               href={getImageUrl(deal?.publicId)}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               <img
//                                 src={
//                                   getImageUrl(deal?.publicId) ||
//                                   "https://via.placeholder.com/400x200"
//                                 }
//                                 alt="Payment Proof"
//                                 style={{
//                                   width: "50px",
//                                   height: "50px",
//                                   objectFit: "cover",
//                                   borderRadius: "5px",
//                                 }}
//                               />
//                             </a>
//                             {/* <button
//                               onClick={() => handleDownload(deal?.publicId)}
//                             >
//                               Download Payment Proof
//                             </button> */}
//                           </Grid>
//                         ) : (
//                           "No Image"
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 ) : (
//                   <TableRow>
//                     <TableCell colSpan={7} align="center">
//                       No deals found
//                     </TableCell>
//                   </TableRow>
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </Grid>
//     </Grid>
//   );
// };

// export default DealsTable;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import { fetchMyDeals } from "../redux/callerSlice/dealsSlice";
import { getImageUrl } from "../utils/helpFunction";

const DealsTable = () => {
  const dispatch = useDispatch();
  const { deals, loading, error } = useSelector((state) => state.deals);
  const [search, setSearch] = useState("");
  const [filteredDeals, setFilteredDeals] = useState([]);

  useEffect(() => {
    dispatch(fetchMyDeals());
  }, [dispatch]);

  useEffect(() => {
    const filtered = deals.filter(
      (deal) =>
        deal.name.toLowerCase().includes(search.toLowerCase()) ||
        deal.email.toLowerCase().includes(search.toLowerCase()) ||
        deal.mobile.includes(search)
    );
    setFilteredDeals(filtered);
  }, [search, deals]);

  return (
    <Grid container>
      <Grid item xs={12} md={12} lg={12} sx={{ borderRadius: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          label="Search by Name, Email, or Mobile"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />

        {loading ? (
          <Grid container justifyContent="center" sx={{ py: 4 }}>
            <CircularProgress />
          </Grid>
        ) : error ? (
          <Typography color="error" align="center">
            {error}
          </Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: "#1976D2" }}>
                <TableRow>
                  <TableCell sx={{ color: "#fff" }}>Name</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Mobile</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Category</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Amount</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Payment Proof</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDeals.length > 0 ? (
                  filteredDeals.map((deal) => (
                    <TableRow key={deal._id} hover>
                      <TableCell>{deal.name}</TableCell>
                      <TableCell>{deal.email}</TableCell>
                      <TableCell>{deal.mobile}</TableCell>
                      <TableCell>{deal.category}</TableCell>
                      <TableCell>₹{deal.amountReceived}</TableCell>
                      <TableCell>{deal.status}</TableCell>
                      <TableCell>
                        {deal.paymentProof ? (
                          <Grid item>
                            <a
                              href={getImageUrl(deal?.publicId)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={
                                  getImageUrl(deal?.publicId) ||
                                  "https://via.placeholder.com/400x200"
                                }
                                alt="Payment Proof"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                }}
                              />
                            </a>
                          </Grid>
                        ) : (
                          "No Image"
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No deals found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Grid>
  );
};

export default DealsTable;
